import jwtAuthAxios from "./auth/jwtAuth";

const erpInventoryServices = {};

// El inventario del ERP producto por producto, con stock y posición.
//
// Sale de la última sincronización de catálogo (erp_inventories), no de una
// consulta en vivo: son miles de filas y pedírselas al ERP en cada pantallazo
// sería imposible. La respuesta trae synced_at para mostrar de cuándo es la foto.
erpInventoryServices.getInventories = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/erp_inventories${params}`);
    return data;
};

// Excel de lo que se está viendo, con los filtros aplicados. Exportar el
// universo completo cuando la pantalla muestra un subconjunto es la forma más
// rápida de que alguien decida con la lista equivocada.
erpInventoryServices.exportInventories = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/erp_inventories/export${params}`, {
        responseType: "arraybuffer",
    });
    return data;
};

// Carga de stock por planilla, para los clientes sin ERP. Una bodega por archivo.
erpInventoryServices.downloadTemplate = async () => {
    const { data } = await jwtAuthAxios.get(`/erp_inventories/download_template`, {
        responseType: "arraybuffer",
    });
    return data;
};

erpInventoryServices.importInventory = async (centreId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("centre_id", centreId);

    const { data } = await jwtAuthAxios.post(`/erp_inventories/import`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};

// Posición administrada por Haulers, para los productos cuyo ERP no entrega
// ubicación. Sin bin_code, la quita.
erpInventoryServices.setProductBin = async (payload) => {
    const { data } = await jwtAuthAxios.put(`/erp_inventories/set_bin`, payload);
    return data;
};

// Copia las posiciones que el ERP ya tenía bien a las que administra Haulers.
// Es lo que evita que activar el interruptor signifique empezar de cero.
erpInventoryServices.adoptErpPositions = async () => {
    const { data } = await jwtAuthAxios.post(`/erp_inventories/adopt_erp_positions`, {});
    return data;
};

// Propone posición por rotación para todo lo que no tiene. Solo propone: el
// aplicar es un paso aparte para que nadie descubra que la bodega se reorganizó
// sola.
erpInventoryServices.getSlottingSuggestions = async (params = "") => {
    const { data } = await jwtAuthAxios.get(`/erp_inventories/slotting_suggestions${params}`);
    return data;
};

erpInventoryServices.applySlotting = async (payload) => {
    const { data } = await jwtAuthAxios.post(`/erp_inventories/apply_slotting`, payload);
    return data;
};

// ZPL de etiquetas de producto para los códigos seleccionados. Usa la etiqueta
// de producto ya calibrada sobre el rollo en uso, la misma que se lee con el
// lector de la bodega.
erpInventoryServices.getLabels = async (items) => {
    const { data } = await jwtAuthAxios.post(`/erp_inventories/labels`, { items });
    return data;
};

// Ficha de un producto con su historial de movimientos. Lo que aporta sobre la
// fila del listado es poder auditar los numeros: "7.457 dias de cobertura" no
// dice nada hasta que se ve que vendio 12 unidades en 90 dias.
erpInventoryServices.getDetail = async (code) => {
    const { data } = await jwtAuthAxios.get(`/erp_inventories/detail?code=${encodeURIComponent(code)}`);
    return data;
};

export default erpInventoryServices;
